import { BooleanStatusIndicator } from "./BooleanStatusIndicator";
import { StatusDisplay, StatusDisplayProps } from "./StatusDisplay";

export interface BooleanStatusDisplayProps {
  value: boolean | null | undefined;
  statusProps?: StatusDisplayProps;
}

export function BooleanStatusDisplay({ value, statusProps }: BooleanStatusDisplayProps) {
  return (
    <StatusDisplay
      indicator={<BooleanStatusIndicator value={value} {...statusProps?.indicatorProps} />}
      {...statusProps}
    />
  );
}
